import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import env from '@beam-australia/react-env';
import { dispatch } from 'store';
import { Store } from 'types/store';
import { SESSION_EXPIRED } from 'constants/routeConstants';
import { releaseLockToken } from 'services/RenewalService';
import Button from 'shared/components/Button/Button';
import { setPolicyLockToken } from 'actions/expiryRenewalActions';
import InfoBlock from '../../common-components/InfoBlock/InfoBlock';
import InfoModal from '../../common-components/InfoModal/InfoModal';

const TimeoutWarningModal = () => {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const policyLockToken = useSelector((state: Store) => state.expiryRenewal.policyLockToken);

  const navigate = useNavigate();

  const unsetPolicyLockToken = async () => {
    const response = await releaseLockToken(policyLockToken);
    if (response?.payload) {
      dispatch(setPolicyLockToken(null));
    }
  };

  const forceLogout = () => {
    setWarningModalOpen(false);
    navigate(SESSION_EXPIRED, { state: { logoutAfterNavigate: true } });
  };

  useEffect(() => {
    const parsedTimeout = Number.parseInt(env('PAYMENT_SESSION_TIMEOUT'), 10);
    const paymentTimeout = Number.isFinite(parsedTimeout) ? parsedTimeout : 600000; // 10 minutes if env var is empty

    const tokenTimeout = setTimeout(async () => {
      if (policyLockToken) unsetPolicyLockToken();
      setWarningModalOpen(true);
    }, paymentTimeout);

    return () => {
      clearTimeout(tokenTimeout);
      if (policyLockToken) unsetPolicyLockToken();
    };
  }, [policyLockToken]);

  return (
    <InfoModal
      size="sm"
      className="payment-info text-center"
      show={isWarningModalOpen}
    >
      <InfoBlock header="Session timed out" variant="warning" inline showIcon />
      <div className="py-4 text-left">
        <p className="fw-bold text-center">Your payment session has expired due to inactivity</p>
      </div>
      <Button
        onClickHandler={forceLogout}
        buttonText="Close"
      />
    </InfoModal>
  )
};

export default TimeoutWarningModal;
